import Vue from 'vue';
/* eslint-disable jsdoc/require-param */
/* eslint-disable jsdoc/check-param-names */
/* eslint-disable jsdoc/require-param-type */

const moduleState = {
  panels: [],

  openPanels: {
    left: false,
    right: false,
  },
};
const moduleGetters = {
  /**
   * find a panel if it exists
   *
   * @param state
   * @returns {object}
   */
  getPanel: (state) => (name) => {
    const panel = state.panels.find((panelObj) => panelObj.name === name);

    if (!panel) {
      return false;
    }

    const value = panel.ignoreOtherPanels
      ? state.openPanels[panel.name]
      : state.openPanels[panel.position];

    return {
      ...panel,
      value,
    };
  },

  /**
   * get visibility of a panel, if it exists
   *
   * @param {object} state
   * @param {object} getters
   * @returns {object}
   */
  isPanelOpen: (state, getters) => (name) => {
    const panel = getters.getPanel(name);
    return (panel.value === panel.name);
  },

  /**
   * get name of panel visible for this position, if set
   *
   * @param {object} state
   * @returns {object}
   */
  getPanelPositionValue: (state) => (position) => state.openPanels[position],
};
const moduleActions = {
  /**
   * Register a panel so that it state can be tracked in the left, right, or it's own group
   *
   * @param {object} panel
   * @param {string} panel.name
   * @param {string} panel.position
   * @param {boolean} panel.ignoreOtherPanels
   * @param {boolean} panel.startOpen
   * @returns {object | void}
   */
  // eslint-disable-next-line consistent-return
  registerPanel({ commit, getters }, {
    name,
    position = 'right',
    ignoreOtherPanels = false,
    startOpen = false,
  }) {
    const panel = getters.getPanel(name);

    if (!panel) {
      commit('REGISTER_PANEL', {
        name,
        position,
        ignoreOtherPanels,
        startOpen,
      });
    } else {
      return new Error('Duplicate panel name');
    }
  },

  /**
   * Set the state of a previously registered panel
   *
   * @param {object} panel
   * @param {string} panel.name
   * @param {boolean} panel.value
   * @returns {object | void}
   */
  // eslint-disable-next-line consistent-return
  setPanel({ state, getters, commit }, { name, value = null }) {
    const panel = getters.getPanel(name);
    let localValue = value;

    if (panel) {
      // no value passed means "toggle"
      if (localValue === null) {
        // panels that ignore other panels are treated as their own group
        const panelGroup = panel.ignoreOtherPanels
          ? panel.name
          : panel.position;

        // if the value for openPanels for this group is
        // the name of the panel, it's currently open
        localValue = state.openPanels[panelGroup] === panel.name
          ? false
          : panel.name;
      } else {
        localValue = localValue
          ? panel.name
          : false;
      }

      commit('SET_PANEL', {
        panel,
        value: localValue,
      });
    } else {
      return new Error('Panel not found');
    }
  },
};
const moduleMutations = {
  /**
   * Register a panel so that it state can be tracked in the left, right, or it's own group
   *
   * @param state
   * @param {object} panel
   */
  REGISTER_PANEL(state, panel) {
    // IF: this is a panel that ignores other panels, it gets it's
    // own entry in openPanels
    // ELSE IF: otherwise, openPanels [left or right] only gets set
    // if the panel needs to start open
    if (panel.ignoreOtherPanels) {
      const value = panel.startOpen
        ? panel.name
        : false;

      Vue.set(state.openPanels, panel.name, value);
    } else if (panel.startOpen) {
      state.openPanels[panel.position] = panel.name;
    }

    // all good to go, already validated in the action
    state.panels.push(panel);
  },

  /**
   * Set the state of a previously registered panel
   *
   * @param state
   * @param panel.panel
   * @param {object} panel
   * @param {boolean | string} value
   * @param panel.value
   */
  SET_PANEL(state, { panel, value }) {
    // panels that ignore other panels are treated as their own group
    const panelGroup = panel.ignoreOtherPanels
      ? panel.name
      : panel.position;

    Vue.set(state.openPanels, panelGroup, value);
  },
};

export default {
  state: moduleState,
  getters: moduleGetters,
  actions: moduleActions,
  mutations: moduleMutations,
};
